export enum BusinessType {
  RETAIL = "RETAIL",
  FLEET = "FLEET",
}
